var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',_vm._g(_vm._b({},'v-card-title',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }